













































import {Component, Prop, Vue} from "vue-property-decorator";
import Company from "@/model/company";
import click2Top from "@/common/directives/click2Top";
import {namespace} from "vuex-class";
const authStore = namespace("Auth");
@Component({
  name: "CompanyInfoView",
  directives: {
    click2Top,
  },
})
export default class CompanyInfoView extends Vue {
  @Prop({
    default: () => {
      return new Company();
    },
  })
  company: Company;

  @authStore.Getter
  public isOwner;
  @authStore.Getter
  public isManager;
}
